import { MultiEhrConfig } from '../types/serverConfig';

export function stripPrefix(username: string, multiEhrConfig: MultiEhrConfig): string {
    if (!username) {
        return username;
    }
    const prefixRegex = new RegExp(`${multiEhrConfig.prefix}(${multiEhrConfig.epicInstances.join('|')})+\\.`);

    username = username.replace(prefixRegex, '');
    return username;
}
